<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsRelationsPresse'
});
</script>
<template>
  <ka-container
    code="prog-09-relations-presse"
    :data="page.$info.prog09RelationsPresse">
    <!-- Page formation -->
    <ka-container code="page-formation">
      <PFormationEntete
        instance-class="p-formation-entete--p37"
        h-1="Formation en relations presse"
        texte="La formation est réalisée par un<strong> </strong>expert en<strong> relations presse </strong>issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog09RelationsPresse.pageFormation.containerExperts.titre.value', `Nos experts en relation presse`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog09RelationsPresse.pageFormation.containerExperts.texte.value', `En matière de relations presse, Matchers regroupe une communauté d’experts du métier. Toujours en poste, ils sont très opérationnels. Le point de départ de nos formations est de faire matcher le profil idéal pour votre projet en relations presse afin que l’expert crée un parcours de formation adapté à votre équipe et votre entreprise. Tout au long de la formation, l’expert vous guide et vous coache pour faire avancer votre projet.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p37"
            :options="{
              href: `https://www.matchers.fr/expert/622`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Attachée de presse"
            first-name="Vanessa"
            enttreprise="&#64;Spartoo"
            image="https://ucarecdn.com/ab6f4d5f-211c-4bf0-a42c-c5367ee011c8/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p37"
            :options="{
              href: `https://www.matchers.fr/expert/623`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :tags="page.$constants.element2Tags"
            poste="Attaché de presse"
            first-name="Jérôme"
            enttreprise="&#64;Accor Hotels"
            image="https://ucarecdn.com/58f44eca-0be5-4746-93aa-d7d07328d50c/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p37"
            :options="{
              href: `https://www.matchers.fr/expert/220`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :tags="page.$constants.element3Tags"
            poste="Head of marketing"
            first-name="Adélaide"
            enttreprise="&#64;Cheerz"
            image="https://ucarecdn.com/c8181c85-7e3e-45d6-86ca-df60b87d2d16/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog09RelationsPresse.pageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog09RelationsPresse.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p37"
                  titre="I.   Une diffusion de contenu efficace"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-4--p37"
                  titre="II.   Mettre en place et pérenniser ses relations avec la presse"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-5--p37"
                  titre="III.   Sensibiliser ses équipes aux RP"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p37" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p37"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p37" />
      <PFormationMatching
        instance-class="p-formation-matching--p37"
        description-company="<strong>Fotonower</strong> | Entreprise spécialisée dans la reconnaissance d’images par l’IA.<br> <br> <br><strong>Besoin : </strong>Augmenter la notoriété de l'entreprise grâce aux relations presse.<br> "
        expert-text="<strong>Adélaïde </strong>| Responsable communication corporate | &#64;M6<br> <br> <br><strong>Expertise : </strong>Plus de<strong> </strong>8 ans d'expérience en tant que responsable de la communication (mise en place et mise en œuvre de plans de communication)."
        budget-available="1 600€"
        training-hours="15h"
        photo-expert="https://ucarecdn.com/ae443fd9-d2ea-4a5b-89e7-ddacc4a3b075/"
        image="https://ucarecdn.com/c86cbfce-07b7-48c5-a9ad-133956eaf9fa/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p37" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p37" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsRelationsPresse } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p37')
const appData = appDataStore()
const page = formationsRelationsPresse()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
